import { type ParamTypesOf } from 'hb-react/shared/hooks/useParsedQueryParams/types';

export interface PaginationParams {
  limit: number;
  order?: 'asc' | 'desc';
  page: number;
  sortBy?: string;
}

export const paramTypesForPagination = ({
  defaultPageSize,
}: {
  defaultPageSize: number;
}): ParamTypesOf<PaginationParams> => ({
  limit: { type: 'number', defaultValue: defaultPageSize },
  page: { type: 'number', defaultValue: 1 },
  order: { type: 'string' },
  sortBy: { type: 'string' },
});
